var cleanupObj = {
	//en
	"en":{
		"stopwords_tags": [
			"city",
			"county",
			"country",
			"town",
			"shire",
			"park",
			":",
			"^",
			"information",
			"month",
			"year",
			"week",
			"day"
		],
		
		"stopwords_time": [
		 "created",
		 "modified",
		 "yesterday",
		 "today",
		 "month",
		 "year",
		 "last",
		 "week"
		],
		
		"stopwords_geo": [
		"*",
		"popular",
		"documents",
		"document",
		"related",
		"published",
		"created",
		"modified",
		"month",
		"week",
		"year",
		"latest",
		"newest",
		"yesterday",	
		"explorer",
		"feature",
		"features",
		"pdf",	
		"jpg",
		"jpeg",
		"city engine",
		"group",
		"sharing",
		"user",
		"catalog",
		"cityengine",
		"scene",
		"sample",
		"ogc",
		"arcmap",
		"arcgis",
		"mxd",
		"data",
		"place",
		"template",		
		"maps",
		"mapservices",
		"mapservice",
		"shapefile",
		"shp",
		"type",
		"webmap",
		"shp",
		"kml",
		"lyr",
		"layer",
		"zip",
		"code",
		"app",
		"apps",
		"test",
		"application",
		"service",
		"services",
		"tile",
		"tiles",
		"file",
		"files",
		"definition",
		"globe",
		"gp",
		"geoprocess",
		"geoprocessing",
		"image",
		"geometry",
		"geodata",
		"network",
		"analysis",
		"dashboard",
		"addin",
		"sd",
		"tpk",
		"wms",
		"doc",
		"docx",
		"ppt",
		"pptx",
		"lpk",
		"gpk",
		"javascript",
		"java",
		"python",
		"arcpy",
		"flex",
		"viewer",
		"operation",
		"web",
		"mapping",
		"attachment",
		"symbol",
		"window",
		"linux",
		"os",
		"color",
		"silverlight",
		"microsoft",
		"google",
		"collection",
		"download"
		],
		
		"stopwords_dict":  [ 
		"@",
		"#",	 	
		"a",
		"a's",
		"able",
		"about",
		"above",
		"according",
		"accordingly",
		"across",
		"actually",
		"after",
		"afterwards",
		"again",
		"against",
		"ain't",
		"all",
		"allow",
		"allows",
		"almost",
		"alone",
		"along",
		"already",
		"also",
		"although",
		"always",
		"am",
		"among",
		"amongst",
		"an",
		"and",
		"another",
		"any",
		"anybody",
		"anyhow",
		"anyone",
		"anything",
		"anyway",
		"anyways",
		"anywhere",
		"apart",
		"appear",
		"appreciate",
		"appropriate",
		"are",
		"aren't",
		"around",
		"as",
		"aside",
		"ask",
		"asking",
		"associated",
		"at",
		"available",
		"away",
		"awfully",
		"b",
		"be",
		"became",
		"because",
		"become",
		"becomes",
		"becoming",
		"been",
		"before",
		"beforehand",
		"behind",
		"being",
		"believe",
		"below",
		"beside",
		"besides",
		"best",
		"better",
		"between",
		"beyond",
		"both",
		"brief",
		"but",
		"by",
		"c",
		"c'mon",
		"c's",
		"came",
		"can",
		"can't",
		"cannot",
		"cant",
		"cause",
		"causes",
		"certain",
		"certainly",
		"changes",
		"clearly",
		"co",
		"com",
		"come",
		"comes",
		"concerning",
		"consequently",
		"consider",
		"considering",
		"contain",
		"containing",
		"contains",
		"corresponding",
		"could",
		"couldn't",
		"course",
		"currently",
		"d",
		"definitely",
		"described",
		"despite",
		"did",
		"didn't",
		"different",
		"do",
		"does",
		"doesn't",
		"doing",
		"don't",
		"done",
		"down",
		"downwards",
		"during",
		"e",
		"each",
		"edu",
		"eg",
		"eight",
		"either",
		"else",
		"elsewhere",
		"enough",
		"entirely",
		"especially",
		"et",
		"etc",
		"even",
		"ever",
		"every",
		"everybody",
		"everyone",
		"everything",
		"everywhere",
		"ex",
		"exactly",
		"example",
		"except",
		"f",
		"far",
		"few",
		"fifth",
		"find",
		"finding",
		"first",
		"five",
		"followed",
		"following",
		"follows",
		"for",
		"former",
		"formerly",
		"forth",
		"four",
		"from",
		"further",
		"furthermore",
		"g",
		"get",
		"gets",
		"getting",
		"given",
		"gives",
		"go",
		"goes",
		"going",
		"gone",
		"got",
		"gotten",
		"greetings",
		"h",
		"had",
		"hadn't",
		"happens",
		"hardly",
		"has",
		"hasn't",
		"have",
		"haven't",
		"having",
		"he",
		"he's",
		"hello",
		"help",
		"hence",
		"her",
		"here",
		"here's",
		"hereafter",
		"hereby",
		"herein",
		"hereupon",
		"hers",
		"herself",
		"hi",
		"him",
		"himself",
		"his",
		"hither",
		"hopefully",
		"how",
		"howbeit",
		"however",
		"i",
		"i'd",
		"i'll",
		"i'm",
		"i've",
		"ie",
		"if",
		"ignored",
		"immediate",
		"in",
		"inasmuch",
		"inc",
		"indeed",
		"indicate",
		"indicated",
		"indicates",
		"inner",
		"insofar",
		"instead",
		"into",
		"inward",
		"is",
		"isn't",
		"it",
		"it'd",
		"it'll",
		"it's",
		"its",
		"itself",
		"j",
		"just",
		"k",
		"keep",
		"keeps",
		"kept",
		"know",
		"knows",
		"known",
		"l",
		"last",
		"lately",
		"later",
		"latter",
		"latterly",
		"least",
		"less",
		"lest",
		"let",
		"let's",
		"like",
		"liked",
		"likely",
		"little",
		"look",
		"looking",
		"looks",
		"ltd",
		"m",
		"made",
		"mainly",
		"many",
		"may",
		"maybe",
		"me",
		"mean",
		"meanwhile",
		"merely",
		"might",
		"more",
		"moreover",
		"most",
		"mostly",
		"much",
		"must",
		"my",
		"myself",
		"n",
		"name",
		"namely",
		"nd",
		"near",
		"nearly",
		"necessary",
		"need",
		"needs",
		"neither",
		"never",
		"nevertheless",
		//"new",
		"next",
		"nine",
		"no",
		"nobody",
		"non",
		"none",
		"noone",
		"nor",
		"normally",
		"not",
		"nothing",
		"novel",
		"now",
		"nowhere",
		"o",
		"obviously",
		"of",
		"off",
		"often",
		"oh",
		"ok",
		"okay",
		"old",
		"on",
		"once",
		"one",
		"ones",
		"only",
		"onto",
		"or",
		"other",
		"others",
		"otherwise",
		"ought",
		"our",
		"ours",
		"ourselves",
		"out",
		"outside",
		"over",
		"overall",
		"own",
		"p",
		"particular",
		"particularly",
		"per",
		"perhaps",
		"placed",
		"please",
		"plus",
		"possible",
		"presumably",
		"probably",
		"provides",
		"q",
		"que",
		"quite",
		"qv",
		"r",
		"rather",
		"rd",
		"re",
		"really",
		"reasonably",
		"regarding",
		"regardless",
		"regards",
		"relatively",
		"respectively",
		"right",
		"s",
		"said",
		"same",
		"saw",
		"say",
		"saying",
		"says",
		"second",
		"secondly",
		"see",
		"seeing",
		"seem",
		"seemed",
		"seeming",
		"seems",
		"seen",
		"self",
		"selves",
		"sensible",
		"sent",
		"serious",
		"seriously",
		"seven",
		"several",
		"shall",
		"she",
		"should",
		"shouldn't",
		"show",
		"since",
		"six",
		"so",
		"some",
		"somebody",
		"somehow",
		"someone",
		"something",
		"sometime",
		"sometimes",
		"somewhat",
		"somewhere",
		"soon",
		"sorry",
		"specified",
		"specify",
		"specifying",
		"still",
		"sub",
		"such",
		"sup",
		"sure",
		"t",
		"t's",
		"take",
		"taken",
		"tell",
		"tends",
		"th",
		"than",
		"thank",
		"thanks",
		"thanx",
		"that",
		"that's",
		"thats",
		"the",
		"their",
		"theirs",
		"them",
		"themselves",
		"then",
		"thence",
		"there",
		"there's",
		"thereafter",
		"thereby",
		"therefore",
		"therein",
		"theres",
		"thereupon",
		"these",
		"they",
		"they'd",
		"they'll",
		"they're",
		"they've",
		"think",
		"third",
		"this",
		"thorough",
		"thoroughly",
		"those",
		"though",
		"three",
		"through",
		"throughout",
		"thru",
		"thus",
		"to",
		"together",
		"too",
		"took",
		"toward",
		"towards",
		"tried",
		"tries",
		"truly",
		"try",
		"trying",
		"twice",
		"two",
		"u",
		"un",
		"under",
		"unfortunately",
		"unless",
		"unlikely",
		"until",
		"unto",
		"up",
		"upon",
		"us",
		"use",
		"used",
		"useful",
		"uses",
		"using",
		"usually",
		"uucp",
		"v",
		"value",
		"various",
		"very",
		"via",
		"viz",
		"vs",
		"w",
		"want",
		"wants",
		"was",
		"wasn't",
		"way",
		"we",
		"we'd",
		"we'll",
		"we're",
		"we've",
		"welcome",
		"well",
		"went",
		"were",
		"weren't",
		"what",
		"what's",
		"whatever",
		"when",
		"whence",
		"whenever",
		"where",
		"where's",
		"whereafter",
		"whereas",
		"whereby",
		"wherein",
		"whereupon",
		"wherever",
		"whether",
		"which",
		"while",
		"whither",
		"who",
		"who's",
		"whoever",
		"whole",
		"whom",
		"whose",
		"why",
		"will",
		"willing",
		"wish",
		"with",
		"within",
		"without",
		"won't",
		"wonder",
		"would",
		"would",
		"wouldn't",
		"x",
		"y",
		"yes",
		"yet",
		"you",
		"you'd",
		"you'll",
		"you're",
		"you've",
		"your",
		"yours",
		"yourself",
		"yourselves",
		"z",
		"zero"
	 ],
	 
	 
	 "searchKeywords" : {
		"map":"map",
		"maps":"maps",
		"webmap":"webmap",
		"webmaps":"webmaps",
		"basemap":"basemap",
		"basemaps":"basemaps",
		"presentation":"presentation",
		"presentations":"presentations",
		"webapp":"webapp",
		"webapps":"webapps",
		"app":"app",
		"apps":"apps",
		"mobile":"mobile",
		"code":"code",
		"cityengine":"cityengine",
		"webscene":"webscene",
		"3d":"3d",
		"globe":"globe",
		"templates":"templates",
		"tpk":"tpk","map":"map",
		"lyr":"lyr",
		"layer":"layer",
		"tiles":"tiles",
		"data":"data",
		"image":"image",
		"pptx":"pptx",
		"document":"document",
		"documents":"documents",
		"mapservice":"mapservice",
		"mapservices":"mapservices",
		"feature":"feature",
		"features":"features",
		"featureservice":"feature service",
		"featureservices":"features ervices",
		"service":"service",
		"services":"services","map":"map","map":"map",
		"imagery":"imagery",
		
		"popular":"popular",
		"oldest": "oldest",
		
		"lastyear": "last year",
		"lastmonth": "last month",
		"week": "week",
		"month": "month",
		"year": "year",
		"today": "today",
		"latest": "latest",
		"yesterday": "yesterday",
		"in": "in",
		"at": "at",
	 } // End of searchKeywords
	},
	
	//zh-cn
	"zh":{
		"stopwords_tags": [
			 "城市",
  "郡",
  "县",
  "省",
  "市",
  "国家",
  "城镇",
  "镇",
  "村",
  "村落",
  "乡村",
  "公园",
  "信息",
  "资讯",
  "月",
  "年",
  "周",
  "星期",
  "天",
  "季度"
		],
		
		"stopwords_time": [
		 "创建",
  "编辑",
  "调整",
  "改变",
  "昨天",
  "今天",
  "月",
  "年",
  "上",
  "周",
  "星期"
		],
		
		"stopwords_geo": [
		 "受欢迎",
  "流行",
  "文档",
  "文本",
  "相关",
  "发布",
  "创建",
  "编辑",
  "月",
  "周",
  "星期",
  "年",
  "最近",
  "最新",
  "昨天",
  "探索",
  "要素",
  "特征",
  "城市引擎",
  "组",
  "分享",
  "用户",
  "目录",
  "场景",
  "样本",
  "数据",
  "地点",
  "地方",
  "模板",
  "地图",
  "地图服务",
  "类型",
  "种类",
  "网页地图",
  "网络地图",
  "图层",
  "压缩文件",
  "压缩包",
  "代码",
  "软件",
  "应用",
  "测试",
  "服务",
  "图块",
  "地图图块",
  "文件",
  "定义",
  "地球",
  "地理处理",
  "图片",
  "图像",
  "几何",
  "地理数据",
  "网络",
  "分析",
  "仪表盘",
  "仪表板",
  "插件",
  "图块包",
  "地图图块包",
  "幻灯片",
  "图层包",
  "浏览器",
  "操作",
  "运行",
  "网",
  "绘图",
  "制图",
  "附件",
  "符号",
  "窗口",
  "操作系统",
  "颜色",
  "微软",
  "谷歌",
  "搜集",
  "收集",
  "集合",
  "下载"
		],
		
		"stopwords_dict":  [ 
		"找",
  "想",
  "要",
  "需",
  "的",
  "关",
  "一",
  "不",
  "在",
  "人",
  "有",
  "是",
  "为",
  "以",
  "于",
  "上",
  "他",
  "而",
  "后",
  "之",
  "来",
  "及",
  "了",
  "因",
  "下",
  "可",
  "到",
  "由",
  "这",
  "与",
  "也",
  "此",
  "但",
  "并",
  "个",
  "其",
  "已",
  "无",
  "小",
  "我",
  "们",
  "起",
  "最",
  "再",
  "今",
  "去",
  "好",
  "只",
  "又",
  "或",
  "很",
  "亦",
  "某",
  "把",
  "那",
  "你",
  "乃",
  "它",
  "吧",
  "被",
  "比",
  "别",
  "趁",
  "当",
  "从",
  "到",
  "得",
  "打",
  "凡",
  "儿",
  "尔",
  "该",
  "各",
  "给",
  "跟",
  "和",
  "何",
  "还",
  "即",
  "几",
  "既",
  "看",
  "据",
  "数",
  "距",
  "靠",
  "啦",
  "了",
  "另",
  "么",
  "每",
  "们",
  "嘛",
  "拿",
  "哪",
  "那",
  "您",
  "凭",
  "且",
  "却",
  "让",
  "仍",
  "啥",
  "如",
  "若",
  "使",
  "谁",
  "虽",
  "随",
  "同",
  "所",
  "她",
  "哇",
  "嗡",
  "往",
  "哪",
  "些",
  "向",
  "沿",
  "哟",
  "用",
  "于",
  "咱",
  "则",
  "怎",
  "曾",
  "至",
  "致",
  "着",
  "诸",
  "自"
	 ],
	 
	 "searchKeywords" : {
		"map":"map",
		"maps":"地图",
		"webmap":"网络地图",
		"webmaps":"webmaps",
		"basemap":"网页地图",
		"basemaps":"底图",
		"presentation":"展示",
		"presentations":"展示",
		"webapp":"webapp",
		"webapps":"webapps",
		"app":"软件",
		"apps":"网页软件",
		"mobile":"移动",
		"code":"代码",
		"cityengine":"城市引擎",
		"webscene":"三维",
		"3d":"3维",
		"globe":"地球",
		"templates":"模板",
		"tpk":"地图图块包",
		"lyr":"lyr",
		"layer":"图层",
		"tiles":"地图图块",
		"data":"数据",
		"image":"图像",
		"images":"图片",
		"pptx":"幻灯片",
		"document":"文档",
		"documents":"文本",
		"mapservice":"mapservice",
		"mapservices":"地图服务",
		"feature":"特征",
		"features":"特征",
		"featureservice":"要素服务",
		"featureservices":"特征服务",
		"service":"service",
		"services":"服务",
		"imagery":"影像",
		"popular":"最受欢迎",
		"oldest": "最老",
		
		"lastyear": "去年",
		"lastmonth": "上个月",
		"week": "周",
		"month": "月",
		"year": "年",
		"today": "今天",
		"latest": "最近的",
		"yesterday": "昨天",
		"in": "在",
		"at": "的",
		
		
	 } // End of searchKeywords
	}
	
	//other language
}
